const convertArrayToString = (variable, delimiter = ', ') => {
  if (Array.isArray(variable)) {
    return variable.join(delimiter)
  }

  return variable
}

const convertObjectValuesToString = (variable) => {
  if (typeof variable !== 'string') {
    if (Array.isArray(variable)) {
      return variable.join(', ')
    }

    const values = Object.values(variable).reduce((sum, arrayMsg) => {
      const messageJoined = arrayMsg.join(' ')

      return sum.concat(messageJoined)
    }, [])

    return values.join(' ')
  }

  return variable
}

export { convertArrayToString, convertObjectValuesToString }



// WEBPACK FOOTER //
// ./src/utils/object.js